import React, { useMemo } from 'react'
import './CardsBlockPreview.scss'

const CardsBlockPreview = ({ cards, colorTheme, backgroundImage }) => {
    const getItemsCell = useMemo(() => {
        return cards.map(card => {
            return (
                <div key={card.id} className="cards-block-preview__card">
                    <img
                        className="cards-block-preview__card-cover-image"
                        src={card.coverImage}
                        alt={card.disclaimer}
                    />
                    <div className="cards-block-preview__card-disclaimer">{card.disclaimer}</div>
                </div>
            )
        })
    }, [cards])

    return (
        <div
            className="cards-block-preview"
            style={{ backgroundColor: colorTheme, backgroundImage: `url(${backgroundImage})` }}
        >
            {getItemsCell}
        </div>
    )
}

export default CardsBlockPreview
